import React from 'react'
import { Link, usePage } from '@inertiajs/inertia-react'
import { Inertia } from '@inertiajs/inertia'
import Layout from '../../../../Shared/Layout/LayoutAdmin'
import Breadcrumbs from '../../../../Shared/Components/Breadcrumbs'
import Form from 'react-bootstrap/Form'

const Results = ({ users, filters }) => {
    const { flash } = usePage().props
    const [search, setSearch] = React.useState(filters.search || '')
    const rows = users.data || []

    return (
        <>
            <div className="mb-5 mt-5">
                <Breadcrumbs currentPath="/admin/sia/manage/examenes/resultados" />
            </div>
            <div className="d-flex justify-content-between align-items-center mb-6">
                <h1 className="fs-2 fw-bold mb-0">Resultados de exámenes</h1>
                <Link href={route('sia.manage.exams.index')} className="btn btn-sm btn-light">Exámenes</Link>
            </div>
            {flash?.success && <div className="alert alert-success">{flash.success}</div>}
            {flash?.error && <div className="alert alert-danger">{flash.error}</div>}
            <Form
                className="d-flex gap-3 mb-6"
                onSubmit={(event) => {
                    event.preventDefault()
                    Inertia.get(route('sia.manage.exams.results'), { search }, { preserveState: true })
                }}
            >
                <Form.Control value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Nombre o correo" />
                <button type="submit" className="btn btn-primary">Buscar</button>
            </Form>
            <div className="card">
                <div className="card-body">
                    <table className="table table-row-dashed align-middle">
                        <thead>
                            <tr className="fw-bold text-gray-500">
                                <th>Usuario</th>
                                <th>Correo</th>
                                <th>Intentos</th>
                                <th />
                            </tr>
                        </thead>
                        <tbody>
                            {rows.length === 0 && (
                                <tr><td colSpan={4} className="text-muted py-6">Nadie ha presentado un examen.</td></tr>
                            )}
                            {rows.map((user) => (
                                <tr key={user.id}>
                                    <td className="fw-semibold">{user.name}</td>
                                    <td>{user.email}</td>
                                    <td>{user.attempts_count}</td>
                                    <td className="text-end">
                                        <Link href={route('sia.manage.exams.results.show', user.id)} className="btn btn-sm btn-light-primary">Ver detalle</Link>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

Results.layout = (page) => <Layout title="Resultados de exámenes">{page}</Layout>

export default Results
